// test298
(298 && 0);
